function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200 200",
    style: {
      enableBackground: "new 0 0 200 200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3B086B"
    },
    d: "M25,180.8c-7.8,0-14.1-6.4-14.2-14.2V50c0-12.8,9.7-22.5,22.5-22.5h72.5v11.7H33.3 c-6.4,0-10.8,4.5-10.8,10.8c0,6.4,4.5,10.8,10.8,10.8H175c7.8,0,14.2,6.4,14.2,14.2v91.7c0,7.8-6.4,14.2-14.2,14.2L25,180.8 L25,180.8z M25,70.8c-0.5,0-1,0.2-1.5,0.5c-0.7,0.5-1,1.2-1,2v93.3c0,1.4,1.1,2.5,2.5,2.5h150c1.4,0,2.5-1.1,2.5-2.5V75 c0-1.4-1.1-2.5-2.5-2.5H33.3c-2.9,0-5.2-0.7-7.5-1.5C25.5,70.9,25.3,70.8,25,70.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3B086B"
    },
    d: "M58.5,116.7l8.1-8.1l23.2,23.2c0.5,0.5,1.1,0.7,1.8,0.7s1.3-0.3,1.8-0.7l39.9-39.9l8.1,8.1 l-49.8,49.8L58.5,116.7z M166.7,72.5c-2.4,0-4-1.1-5.3-3.6l-21.7-42.5c-0.4-0.8-1.3-1.4-2.2-1.4c-0.4,0-0.8,0.1-1.1,0.3L43.9,71.9 c-0.5,0.2-1.1,0.4-1.7,0.4c-2.2,0-4.5-1.4-5.8-3.5c-0.9-2,0.1-5.5,3.2-7.4l99.8-49.9c0.7-0.3,1.6-0.4,2.4-0.4c2.3,0,4.4,1.1,5.1,2.6 l25,49.9c1.2,3.1-0.2,6.5-2.2,7.6c-0.2,0.1-0.5,0.3-0.7,0.5C168.1,72.5,168.1,72.5,166.7,72.5z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.257e889d3093d7bac25b1a435408235d.svg";
export { ForwardRef as ReactComponent };